// ===============================
// File: bridge-quote-preview-v2.component.ts
// ===============================
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  inject,
  AfterViewInit,
  OnDestroy,
  ElementRef,
  ViewChild,
  ViewChildren,    // <-- manquait
  QueryList,       // <-- manquait
  HostListener,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';
import { formatUnits } from 'ethers';
// ⬇️ IMPORT SERVICE (ajuste le chemin si besoin)
import { BalanceValidatorService } from '../services/balance-validator.service'; // <-- adjust path
const ZERO_ADDR = '0x0000000000000000000000000000000000000000';
const DEFAULT_SLIPPAGE_BPS = 100; // 1%
// Shape léger pour une route/quote (remplace par tes vraies interfaces)
export interface BridgeQuoteLike {
  provider?: string;
  providerLogo?: string;

  // montants (raw/pretty)
  estimatedBuyAmount?: string | number; // reçu (token)
  estimatedBuyFiat?: number;            // ≈ en devise sélectionnée
  sellSymbol?: string;
  buySymbol?: string;

  // pricing
  rate?: number;                        // 1 SELL = rate BUY
  priceImpactPct?: number | null;
  maxSlippagePct?: number | null;

  // temps
  estimatedDurationSeconds?: number | null;

  // fees (idéalement champs LiFi normalisés)
  lifiGasAmountWei?: string | number | bigint;
  lifiGasPriceWei?: string | number | bigint;
  lifiEstimatedGas?: string | number | bigint;
  gasTokenSymbol?: string;              // POL, ETH, etc.
  bridgeFeeFiat?: number | null;        // si fourni par le backend

  // exécution (enable/disable validate pour alternatives)
  to?: string | null;
  data?: string | null;

  bridgeName?: string;
  BridgeName?: string;
  bridgeIcon?: string;
  BridgeIcon?: string;
  providerName?: string;
  providerKey?: string;
  providerLogoUrl?: string;
  logoURI?: string;

  toolDetails?: { name?: string; logoURI?: string } | null;
  steps?: Array<{ toolDetails?: { name?: string; logoURI?: string } | null }> | null;
  route?: { toolDetails?: { name?: string; logoURI?: string } | null } | null;
  singleRoutes?: any[] | null;   // parfois le nom/logo ne vit que dans la route sélectionnée
  SingleRoutes?: any[] | null;   // variante de casse
}
type CtaAction = 'connect' | 'approve_then_validate' | 'validate' | null;
type CtaState = {
  label: string;                // "Connect wallet" | "Approve + Validate" | "Validate" | "Approving…" | "Validating…" | "Preparing…"
  disabled: boolean;
  action: CtaAction;            // ce que ton click doit déclencher
  reasons?: string[];           // raisons si disabled
  deficit?: { native: string; fiat: string } | null;  // montant manquant si gas insuffisant
};
@Component({
  selector: 'app-bridge-quote-preview-v2',
  standalone: true,
  imports: [CommonModule, TranslateModule], // ✅ NgIf, NgFor, NgClass, number pipe
  templateUrl: './bridge-quote-preview-v2.component.html',
  styleUrls: ['./bridge-quote-preview-v2.component.scss'],
})
export class BridgeQuotePreviewV2Component implements OnChanges {
  // ===== Inputs =====
  @Input() quote: BridgeQuoteLike | null = null;         // route principale
  @Input() otherRoutes: BridgeQuoteLike[] = [];          // alternatives

  // Contexte FIAT
  @Input() selectedCurrency: string = 'EUR';
  @Input() fiatRates: Record<string, number> | null = null;
  @Input() outTokenPriceUSD?: number;
  @Input() gasFeePriceUSD?: number;
  @Input() inTokenPriceUSD?: number;   // prix USD du token vendu (comme en V1)

  // Contexte gating (miroir de tes props existantes)
  @Input() takerAddress?: string | null;
  @Input() chainId?: number | null;                      // fallback
  @Input() sellTokenSymbol?: string | null;
  @Input() sellAmount?: string | number | null;
  @Input() availableSellTokens?: any[] | null;           // remplace par ton vrai type
  @Input() sellTokenBalances: Record<string, string | number> = {};

  // ⬅️ Ajouts pour BalanceValidatorService
  @Input() fullGasWei?: string | number | bigint | null;
  @Input() getNativeTokenSymbol?: (cid: number) => string;

  // Statut (success/pending/error) — inclut alias 'approve'
  @Input() bridgeStatus?: 'idle' | 'approve' | 'approving' | 'pending' | 'success' | 'cancelled' | 'error' | null;
  @Input() bridgeHash?: string | null;
  @Input() bridgeError?: string | null;
  @Input() buyTokenSymbol?: string | null;   // ⬅️ AJOUT
  // ===== Outputs =====
  @Output() executeRequest = new EventEmitter<void>();           // valider la route principale
  @Output() executeAlt = new EventEmitter<BridgeQuoteLike>();    // valider une alternative
  @Output() share = new EventEmitter<void>();                    // bouton share (optionnel)


  // 🔽 ajout en haut des @Input()
  @Input() nativeBalanceWei?: string | number | bigint | null; // solde natif utilisateur (wei)
  @Input() needsApproval?: boolean;                               // main
  @Input() needsApprovalForAlt?: (r: any) => boolean;             // alt (predicate)


  private _showMainDetails = false;

  @Output() requestConnect = new EventEmitter<void>();


  @Input() bypassDebug: boolean = false;

  // + en haut avec les autres @Output()
  @Output() close = new EventEmitter<void>();
  // === Sticky footer state
  isExpanded = false;
  showStickyFooter = false;

  @ViewChild('scrollArea') scrollArea?: ElementRef<HTMLDivElement>;
  @ViewChild('altScrollArea') altScrollArea?: ElementRef<HTMLDivElement>;
 /** --- Inline “Why disabled” (desktop) : timeout 4s --- */
    showWhyMain = true;                       // bloc principal
  showWhyAlt: Record<number, boolean> = {};  // bloc par alternative (index)
  lastAltStatusIndex: number | null = null;
  expandedAltIndex: number | null = null;
    // --- Explorers par chaîne (base URL) ---
  private readonly explorerMap: Record<number, string> = {
    1: 'https://etherscan.io',
    10: 'https://optimistic.etherscan.io',
    56: 'https://bscscan.com',
    137: 'https://polygonscan.com',
    250: 'https://ftmscan.com',
    42161: 'https://arbiscan.io',
    43114: 'https://snowtrace.io',
    8453: 'https://basescan.org',
    59144: 'https://lineascan.build',
    324: 'https://explorer.zksync.io',
  };

  /** Retourne l’URL de l’explorateur pour un hash donné, en fonction de la chaîne. */
  getExplorerTxUrl(chainId?: number, hash?: string | null): string {
    if (!hash) return '';
    const base = (chainId && this.explorerMap[chainId]) ? this.explorerMap[chainId] : 'https://etherscan.io';
    return `${base}/tx/${hash}`;
  }

    pickChainIdForTx(r?: any): number {
    // 1) Priorité: toChainId (destination), puis fromChainId si absent
    const fromR = Number(r?.fromChainId);
    const toR   = Number(r?.toChainId);
    if (Number.isFinite(toR) && toR > 0) return toR;
    if (Number.isFinite(fromR) && fromR > 0) return fromR;

    // 2) Sinon, essayer la quote principale (si elle a des champs similaires)
    const q: any = this.quote || {};
    const fromQ = Number(q?.fromChainId);
    const toQ   = Number(q?.toChainId);
    if (Number.isFinite(toQ) && toQ > 0) return toQ;
    if (Number.isFinite(fromQ) && fromQ > 0) return fromQ;

    // 3) Fallback: inputs du composant
    const sel = Number(this.chainId);
    if (Number.isFinite(sel) && sel > 0) return sel;

    // 4) Dernier recours: Ethereum
    return 1;
  }
  // timers par message (main = -1, alt = index)
  private whyReShowTimers: Record<string, number> = {};

  revealMainWhy(): void {
    this.showWhyMain = true;
    this.restartWhyTimer(-1);
  }

  revealAltWhy(i: number): void {
    this.showWhyAlt[i] = true;
    this.restartWhyTimer(i);
  }

  private restartWhyTimer(i: number): void {
    const key = String(i);
    if (this.whyReShowTimers[key]) {
      window.clearTimeout(this.whyReShowTimers[key]);
    }
    this.whyReShowTimers[key] = window.setTimeout(() => {
      if (i === -1) this.showWhyMain = false;
      else this.showWhyAlt[i] = false;
    }, 4000);
  }

  onShareClick(): void {
    const q: any = this.quote || {};

    // Origine + même chemin (conserve /bridge si tu y es)
    const base = window.location.origin + window.location.pathname;

    // Tokens IN/OUT
    const tokenIn =
      this.sellTokenSymbol ??
      q?.sellSymbol ?? q?.fromTokenSymbol ?? q?.fromToken?.symbol ?? '';

    const tokenOut =
      q?.buySymbol ?? q?.toTokenSymbol ?? q?.toToken?.symbol ?? '';

    // Chaînes (from/to)
    const fromChainId = Number(this.chainId ?? q?.fromChainId ?? '');
    const toChainId = Number(q?.toChainId ?? '');

    // Montant d'entrée (formaté)
    const amountIn = this._formattedSellAmount?.() ?? String(this.sellAmount ?? '');

    // URL partageable (encode proprement)
    const params = new URLSearchParams({
      tokenIn: tokenIn || '',
      tokenOut: tokenOut || '',
      amountIn: amountIn || '',
      fromChainId: Number.isFinite(fromChainId) ? String(fromChainId) : '',
      toChainId: Number.isFinite(toChainId) ? String(toChainId) : ''
    });

    const shareUrl = `${base}?${params.toString()}`;

    // Texte (tu peux inclure un résumé si tu veux)
    const text = this.translate.instant('DEFI_BRIDGE_OPPORTUNITY');

    if (navigator.share) {
      navigator.share({
        title: 'SmartSwap',
        text,
        url: shareUrl
      }).catch(() => {
        // Silencieux si l’utilisateur annule
      });
    } else {
      navigator.clipboard.writeText(shareUrl).then(() => {
        // TODO: déclenche ton toast "Link copied" ici
        // this.toast.success(this.translate.instant('LINK_COPIED'));
      });
    }
  }

  /** Détection robuste d’annulation utilisateur (EIP-1193 / MM / Ethers v6). */
  private isUserCancelled(err: any): boolean {
      if (!err) return false;
      // string
        if (typeof err === 'string') {
            const s = err.toLowerCase();
            return s.includes('action_rejected') || s.includes('user denied') || s.includes('user rejected') ||
                     s.includes('rejected by user') || s.includes('request rejected') ||
                     s.includes('cancelled') || s.includes('canceled') || s.includes('code=4001');
          }
      // code
        const code = err?.code ?? err?.error?.code ?? err?.data?.code ?? err?.info?.error?.code ?? err?.cause?.code;
      if (code === 4001 || code === 'ACTION_REJECTED') return true;
      // message
        const reason = err?.reason || err?.shortMessage || err?.error?.message || err?.info?.error?.message ||
                         err?.data?.message || err?.message || '';
      const r = String(reason).toLowerCase();
      return r.includes('action rejected') || r.includes('user denied') || r.includes('user rejected') ||
               r.includes('rejected by user') || r.includes('request rejected') ||
               r.includes('cancelled') || r.includes('canceled');
    }

    /** Vrai si la chaîne ressemble à un gros hex (calldata, RLP…) qu’on ne doit jamais afficher. */
    private isUglyHexBlob(s: any): boolean {
      if (!s || typeof s !== 'string') return false;
      const t = s.trim();
      // 0x + au moins 24 hexdigits (seuil bas pour éviter les faux positifs)
        return /^0x[0-9a-fA-F]{24,}$/.test(t);
    }

    /** Formatte l’erreur pour l’UI : mappe cancel, masque hex, retourne message friendly. */
  getFormattedBridgeError(error: any): string | null {
    if (!error) return null;

    // Annulation → pas d'erreur (le statut 'cancelled' affichera le bon message)
    if (this.isUserCancelled(error)) return null;

    // Extraire un texte "humain" potentiel
    const raw =
      (typeof error === 'string' && error) ||
      error?.reason || error?.shortMessage || error?.error?.message ||
      error?.info?.error?.message || error?.data?.message || error?.message || '';
    const s = String(raw || '').trim();

    // Jamais de dump : hex/calldata, JSON/objets verbeux, ou messages trop longs
    const looksHex = this.isUglyHexBlob(s);
    const looksJsonDump = s.includes('{') || s.includes('}') || s.length > 160;
    if (looksHex || looksJsonDump) return this.translate.instant('BRIDGE_ERROR_GENERIC');

    // Mappings utiles
    const l = s.toLowerCase();
    if (l.includes('insufficient funds')) return this.translate.instant('INSUFFICIENT_FUNDS');
    if (l.includes('intrinsic gas too low') || l.includes('gas required exceeds'))
      return this.translate.instant('GAS_TOO_LOW');
    if (l.includes('execution reverted')) return this.translate.instant('TX_REVERTED');
    if (l.includes('timeout') || l.includes('underpriced')) return this.translate.instant('TX_TIMEOUT');
    if (l.includes('nonce too low')) return this.translate.instant('NONCE_TOO_LOW');
    if (l.includes('already known') || l.includes('already imported'))
      return this.translate.instant('TX_ALREADY_IMPORTED');

    // Fallback générique (jamais de brut)
    return this.translate.instant('BRIDGE_ERROR_GENERIC');
  }


   /** Centralise la décision statut + message après une exception wallet/tx. */
    private handleWalletException(err: any): void {
    if (this.isUserCancelled(err)) {
        // Annulation immédiate et silencieuse (pas d’erreur UX)
          this.bridgeStatus = 'cancelled';
        this.bridgeError  = null;
        return;
      }
    this.bridgeStatus = 'error';
    this.bridgeError  = err; // rendu UI passera par getFormattedBridgeError()
  }

  private computeAboveStyle(btn?: HTMLElement): { [k: string]: string } {
    if (!btn) return {};
    const r = btn.getBoundingClientRect();
    const margin = 8;           // espace entre bouton et popover
    const maxW = 360;           // largeur approx max du popover
    const left = Math.max(8, Math.min(r.right - maxW, window.innerWidth - maxW - 8));
    const top = Math.max(8, r.top - margin); // on posera transform:translateY(-100%)
    return {
      left: `${left}px`,
      top: `${top}px`,
      transform: 'translateY(-100%)',
    };
  }

    private whyTimers: number[] = [];          // clearTimeout pour inline
  private popTimers: number[] = [];          // clearTimeout pour popover

      // Pour éviter de relancer inutilement les timeouts
   private lastRouteSig: string | undefined;   // signature de route
   private lastInlineKey: string | undefined;  // clé "gating" (connex + raisons + disabled)

  /** Construit une signature "stable" de la route courante pour savoir si on doit ré-afficher le toast 4s */
  private buildRouteSignature(): string {
    const q: any = this.quote || {};

    const sellToken =
      this.sellTokenSymbol ??
      q?.sellSymbol ?? q?.fromTokenSymbol ?? q?.fromToken?.symbol ?? '';

    const buyToken =
      q?.buySymbol ?? q?.toTokenSymbol ?? q?.toToken?.symbol ?? '';

    const sellChain = Number(this.chainId ?? q?.fromChainId ?? 1);
    const buyChain = Number(q?.toChainId ?? 0);

    const amount = this.sellAmount;

    const provider =
      this.getProviderKey?.(q) ??
      q?.provider ?? q?.providerName ?? q?.providerKey ??
      q?.bridgeName ?? q?.toolDetails?.name ?? '';

    return JSON.stringify({ sellToken, buyToken, sellChain, buyChain, amount, provider });
  }

    /** Affiche les blocs inline 4s (desktop) puis les masque */
    private scheduleInlineWhyTimeouts(): void {
    // clear anciens timers
        this.whyTimers.forEach(t => window.clearTimeout(t));
    this.whyTimers =[];

      const connected = this.isWalletConnected?.() ?? false;

      // MAIN
      if (connected && this.bridgeDisabled && (this.bridgeReasons?.length ?? 0) > 0) {
          this.showWhyMain = true;
          const t = window.setTimeout(() => (this.showWhyMain = false), 4000);
          this.whyTimers.push(t);
        } else {
        this.showWhyMain = false;
      }

      // ALTS
      if (Array.isArray(this.computedOtherRoutes)) {
          this.computedOtherRoutes.forEach((r: any, i: number) => {
              const disabled = this.isAltValidateDisabled?.(r) ?? false;
              const reasons = this.getAltReasons?.(r) ?? [];
              if (connected && disabled && reasons.length > 0) {
                  this.showWhyAlt[i] = true;
                  const tt = window.setTimeout(() => (this.showWhyAlt[i] = false), 4000);
                  this.whyTimers.push(tt);
                } else {
                  this.showWhyAlt[i] = false;
                }
            });
        }
  }





  // + dans la classe
  closePreview() {
    this.close.emit();
  }


  private _pickFromAmount(): number {
    const q: any = this.quote || {};
    const dec = Number(q?.fromTokenDecimals ?? q?.fromToken?.decimals ?? 18);
    const pretty = Number(q?.inputAmountFormatted);
    if (pretty > 0) return pretty;
    const raw = Number(q?.fromAmountRaw ?? q?.fromAmount);
    return Number.isFinite(raw) ? raw / Math.pow(10, dec) : 0;
  }
  private _pickToAmount(): number | null {
    const q: any = this.quote || {};
    const dec = Number(q?.toTokenDecimals ?? q?.toToken?.decimals ?? 18);
    const pretty = Number(q?.outputAmountFormatted ?? q?.estimatedBuyAmount);
    if (pretty > 0) return pretty;
    const raw = Number(q?.toAmountRaw ?? q?.toAmount);
    return Number.isFinite(raw) ? raw / Math.pow(10, dec) : null;
  }

  onClose(): void {
    const anyThis = this as any;
    if (typeof anyThis.closePreview === 'function') {
      anyThis.closePreview();
      return;
    }
    this.close?.emit?.();
  }

  // ===== Alternatives calculées (source unique  anti-doublon) =====
  private _computedOtherRoutes: BridgeQuoteLike[] = [];
  get computedOtherRoutes(): BridgeQuoteLike[] { return this._computedOtherRoutes; }
  private translate = inject(TranslateService);
  /** Slippage en % (priorité: maxSlippagePct -> slippageBps -> défaut 0.5%) */
  private getSlippagePct(q: any): number {
    const pct = this.toNumSoft(q?.maxSlippagePct);
    if (pct !== null) return Math.max(0, pct);
    const bps = this.toNumSoft(q?.slippageBps);
    if (bps !== null) return Math.max(0, bps / 100);
    return 0.5; // défaut backend
  }
  // Mappe un code → params d'interpolation i18n (optionnels)
  private getReasonParams(code: string, route?: any): any {
    if (code === 'INSUFFICIENT_NATIVE_GAS') {
      const cid = Number(
        route?.fromChainId ?? route?.chainId ?? this.chainId ?? 1
      );
      const symbol =
        (this.getNativeTokenSymbol && this.getNativeTokenSymbol(cid)) || 'ETH';
      return { symbol };
    }
    if (code === 'INSUFFICIENT_SELL_TOKEN') {
      const token =
        route?.sellTokenSymbol ??
        this.sellTokenSymbol ??
        this.quote?.sellSymbol ??
        '';
      return { token };
    }
    return {};
  }

  getReasonLabel(code: string, route?: any): string {
    const key = `BRIDGE_REASON_${code}`;
    const params = this.getReasonParams(code, route);
    const t = (this as any).translate?.instant
      ? (this as any).translate.instant(key, params)
      : key;
    return t && t !== key ? t : code.replace(/_/g, ' ');
  }


  /** Minimum garanti (MAIN) — { amount: "0.0002199 ETH", fiat: "≈ €0.98" } */
  getMainMinGuaranteed(): { amount: string; fiat: string } {
    const q = this.quote;
    if (!q) return { amount: '—', fiat: '—' };

    const amt = this.pickBuyAmount(q);
    if (amt === null) return { amount: '—', fiat: '—' };

    const slip = this.getSlippagePct(q) / 100;
    const minAmt = Math.max(0, amt * (1 - slip));
    const sym = this.pickBuySymbol(q);

    const fiatUsd = this.pickBuyFiat(q); // USD estimé
    const minUsd = (fiatUsd == null) ? null : Math.max(0, fiatUsd * (1 - slip));

    return {
      amount: `${this.formatCryptoTerse(minAmt)} ${sym}`,
      fiat: (minUsd == null) ? '—' : this.usdToSelectedFiat(minUsd)
    };
  }

  /** Minimum garanti (ALT route) — même format que le main */
  getAltMinGuaranteed(r: any): { amount: string; fiat: string } {
    if (!r) return { amount: '—', fiat: '—' };

    const amt = this.pickBuyAmount(r);
    if (amt === null) return { amount: '—', fiat: '—' };

    const slip = this.getSlippagePct(r) / 100;
    const minAmt = Math.max(0, amt * (1 - slip));
    const sym = this.pickBuySymbol(r);

    const fiatUsd = this.pickBuyFiat(r);
    const minUsd = (fiatUsd == null) ? null : Math.max(0, fiatUsd * (1 - slip));

    return {
      amount: `${this.formatCryptoTerse(minAmt)} ${sym}`,
      fiat: (minUsd == null) ? '—' : this.usdToSelectedFiat(minUsd)
    };
  }


  /** Sélectionne la meilleure source d'alternatives (prop otherRoutes sinon quote.singleRoutes) puis filtre les doublons de la route principale. */
  private computeOtherRoutes(): BridgeQuoteLike[] {
    // 1) Source unique des alternatives
    const rawAlts: BridgeQuoteLike[] =
      (Array.isArray(this.otherRoutes) && this.otherRoutes.length > 0)
        ? this.otherRoutes
        : (Array.isArray((this.quote as any)?.singleRoutes) && (this.quote as any).singleRoutes.length > 0)
          ? (this.quote as any).singleRoutes
          : (Array.isArray((this.quote as any)?.SingleRoutes) && (this.quote as any).SingleRoutes.length > 0)
            ? (this.quote as any).SingleRoutes
            : [];

    if (!this.quote || rawAlts.length === 0) return rawAlts;

    // 2) Signature "TX" de la route principale
    const mainSig = this.getTxSig(this.quote);
    const mainProv = this.getProviderKey(this.quote);
    const mainOut = this.getBuyAmount(this.quote);

    // 3) Filtre anti-doublon
    return rawAlts.filter(r => {
      const sameTx = !!mainSig && this.getTxSig(r) === mainSig;
      const sameProv = !!mainProv && this.getProviderKey(r) === mainProv;
      const sameOut = this.getBuyAmount(r) === mainOut;
      // doublon si même TX, ou (même provider ET même montant reçu)
      return !(sameTx || (sameProv && sameOut));
    });
  }

  /** Extrait une signature stable de transaction: to(lowercase)  '#'  data */
  private getTxSig(x: any): string {
    const tx = x?.transactionRequest ?? x?.TransactionRequest ?? null;
    const to = (tx?.to || '').toString().toLowerCase();
    const dat = (tx?.data || '').toString();
    return `${to}#${dat}`;
  }

  /** Normalise une clé provider robuste (providerKey/toolKey/tool/source…) */
  private getProviderKey(x: any): string {
    const raw =
      x?.providerKey ?? x?.ProviderKey ??
      x?.toolKey ?? x?.ToolKey ??
      x?.tool ?? x?.Tool ??
      x?.source ?? x?.Source ??
      x?.providerName ?? x?.ProviderName ??
      x?.bridgeName ?? x?.BridgeName ?? '';
    return String(raw || '').toLowerCase().trim();
  }

  /** Montant reçu sous forme number (tolérant aux string) */
  private getBuyAmount(x: any): number {
    const v = x?.estimatedBuyAmount;
    if (typeof v === 'number') return v;
    if (typeof v === 'string') {
      const n = Number(v.replace(/,/g, '.').replace(/\s/g, ''));
      return Number.isFinite(n) ? n : 0;
    }
    return 0;
  }

  onMainCtaClick() {
    const cta = this.getMainCtaState();

    if (cta.action === 'connect') {
      this.requestConnect.emit();
      return;
    }

    if (cta.action === 'approve_then_validate' || cta.action === 'validate') {
      // UI: passer immédiatement en "pending" + reset messages
      this.bridgeStatus = 'pending';
      this.bridgeError = null;
      this.bridgeHash = null;

      // Au cas où un statut alternatif serait affiché, on repart clean
      if ((this as any).lastAltStatusIndex !== undefined) {
        this.lastAltStatusIndex = null;
      }

      // Laisse Angular rendre l'état puis lance le flux existant
      setTimeout(() => this.executeRequest.emit(), 0);
      return;
    }
  }


  async onAltCtaClick(r: any) {
    const cta = this.getAltCtaState(r);

    if (cta.action === 'connect') {
      this.requestConnect.emit();
      return;
    }

    if (cta.action === 'approve_then_validate' || cta.action === 'validate') {
      // 1) UI: on passe en "pending" immédiatement et on nettoie l'erreur
      const idx = this.computedOtherRoutes.indexOf(r);
      this.lastAltStatusIndex = idx >= 0 ? idx : null;
      this.bridgeStatus = 'pending';
      this.bridgeError = null;

      // Laisse Angular peindre l’état pending
      await Promise.resolve();

      try {
        // 2) Délègue l’exécution au parent
        this.executeAlt.emit(r);
      } catch (e: any) {
        // 3) Normalisation locale au cas où l’émetteur throw (selon l’implémentation parent)
        const code = e?.code ?? e?.error?.code ?? e?.cause?.code;
        const msg = (e?.reason || e?.shortMessage || e?.error?.message || e?.message || '').toString().toLowerCase();

        const isCancel =
          code === 4001 || code === 'ACTION_REJECTED' ||
          msg.includes('action rejected') ||
          msg.includes('user denied') ||
          msg.includes('user rejected') ||
          msg.includes('rejected by user') ||
          msg.includes('request rejected') ||
          msg.includes('cancelled') || msg.includes('canceled');

        if (isCancel) {
          this.bridgeStatus = 'cancelled';
          this.bridgeError = null; // jamais de message brut pour un cancel
          return;
        }

        this.bridgeStatus = 'error';
        // Ne jamais afficher un gros blob hex brut
        const raw = (e?.reason || e?.shortMessage || e?.error?.message || e?.message || '') as string;
        this.bridgeError = /^0x[0-9a-fA-F]{24,}$/.test(raw) ? null : raw;
      }
    }
  }


  
    // === FIRST-REASON HELPERS ======================================
    private pickFirstReason(reasons ?: string[] | null): string | null {
      return Array.isArray(reasons) && reasons.length > 0 ? reasons[0] : null;
    }

    /** Libellé unique (1ʳᵉ raison) pour le WHY main, avec éventuel déficit fiat. */
    getMainFirstReasonLabel(): string | null {
      const first = this.pickFirstReason(this.bridgeReasons);
      if (!first) return null;
      let label = this.getReasonLabel(first);
      if (first === 'INSUFFICIENT_NATIVE_GAS') {
          const d = this.getMainGasDeficitText?.();
          if (d?.native && d?.fiat) {
              label += ` (${this.translate.instant('LABEL.NEED')} ≈ ${d.native} / ${d.fiat})`;
            }
        }
      return label;
    }

    /** Libellé unique (1ʳᵉ raison) pour le WHY d’une alternative r, avec éventuel déficit fiat. */
    getAltFirstReasonLabel(r: any): string | null {
      const reasons = this.getAltReasons?.(r) ?? [];
      const first = this.pickFirstReason(reasons);
      if (!first) return null;
      let label = this.getReasonLabel(first, r);
      if (first === 'INSUFFICIENT_NATIVE_GAS') {
          const d = this.getAltGasDeficitText?.(r);
          if (d?.native && d?.fiat) {
              label += ` (${this.translate.instant('LABEL.NEED')} ≈ ${d.native} / ${d.fiat})`;
            }
        }
      return label;
    }

  getMainCtaLabel(): string { return this.getMainCtaState().label; }
  isMainCtaDisabled(): boolean { return this.getMainCtaState().disabled; }

  getAltCtaLabel(r: any): string { return this.getAltCtaState(r).label; }
  isAltCtaDisabled(r: any): boolean { return this.getAltCtaState(r).disabled; }

  private stripGasIfBypassed(reasons: string[] = []): string[] {
    return this.bypassDebug ? reasons.filter(r => r !== 'INSUFFICIENT_NATIVE_GAS') : reasons;
  }
 

  isWalletConnected(): boolean {
    return !!this.takerAddress;
  }

  private hasInvalidAmountMain(): boolean {
    if (!this.bridgeReasons?.length) return false;
    return this.bridgeReasons.includes('INVALID_AMOUNT');
  }

  private isBusy(): boolean {
    return this.statusNorm === 'approving' || this.statusNorm === 'pending';
  }


  // ✅ CTA principal (main)
  getMainCtaState(): CtaState {
    // 1) Wallet non connecté
    if (!this.isWalletConnected()) {
      return {
        label: this.translate.instant('CONNECT_WALLET'),
        disabled: false,
        action: 'connect'
      };
    }

    // 2) Busy (approve/pending) — uniquement quand on n'est pas sur une alt en cours
    if (this.statusNorm === 'approving' && this.lastAltStatusIndex == null) {
      return { label: this.translate.instant('APPROVING_ELLIPSIS'), disabled: true, action: null };
    }
    if (this.statusNorm === 'pending' && this.lastAltStatusIndex == null) {
      return { label: this.translate.instant('VALIDATING_ELLIPSIS'), disabled: true, action: null };
    }

    // 3) Montant invalide / blocages globaux
    if (this.hasInvalidAmountMain?.()) {
      return {
        label: this.translate.instant('VALIDATE'),
        disabled: true,
        action: null,
        reasons: this.bridgeReasons
      };
    }

    // 4) Gas insuffisant (affiche le déficit si dispo)
    const mainDeficit = this.getMainGasDeficitText?.() ?? null;
    if (mainDeficit) {
      return {
        label: this.translate.instant('VALIDATE'),
        disabled: true,
        action: null,
        reasons: this.bridgeReasons ?? [],
        deficit: mainDeficit
      };
    }

    // 5) Approval requis ?
    const needApprove = !!this.needsApproval;
    if (needApprove) {
      return {
        label: this.translate.instant('APPROVE_AND_VALIDATE'),
        disabled: false,
        action: 'approve_then_validate'
      };
    }

    // 6) OK → Validate
    return {
      label: this.translate.instant('VALIDATE'),
      disabled: !!this.bridgeDisabled,
      action: this.bridgeDisabled ? null : 'validate',
      reasons: this.bridgeReasons ?? []
    };
  }


  getAltCtaState(r: any): CtaState {
    // 1) Wallet
    if (!this.isWalletConnected()) {
      return { label: this.translate.instant('CONNECT_WALLET'), disabled: false, action: 'connect' };
    }

    // 2) Busy — NE bloquer que l’alternative réellement en cours
    if (this.statusNorm === 'approving' || this.statusNorm === 'pending') {
      const idx = this.computedOtherRoutes?.indexOf?.(r) ?? -1;
      const isThisAlt = idx >= 0 && this.lastAltStatusIndex === idx && this.expandedAltIndex === idx;
      if (isThisAlt) {
        return {
          label: this.translate.instant(this.statusNorm === 'approving' ? 'APPROVING_ELLIPSIS' : 'VALIDATING_ELLIPSIS'),
          disabled: true,
          action: null
        };
      }
      // Sinon: on ne force pas le disabled ici, on laisse poursuivre l'évaluation normale
    }

    // 3) Montant invalide / blocages globaux
    const reasons = this.getAltReasons?.(r) ?? [];
    if (this.bridgeReasons?.includes('INVALID_AMOUNT')) {
      return { label: this.translate.instant('VALIDATE'), disabled: true, action: null, reasons: ['INVALID_AMOUNT'] };
    }

    // 4) Gas insuffisant (affiche le déficit spécifique à la route)
    const altDeficit = this.getAltGasDeficitText?.(r) ?? null;
    const altDisabled = this.isAltValidateDisabled?.(r) ?? false;
    if (altDeficit && altDisabled) {
      return { label: this.translate.instant('VALIDATE'), disabled: true, action: null, reasons, deficit: altDeficit };
    }

    // 5) Approval requis pour CETTE route ?
    const needApproveAlt = this.needsApprovalForAlt?.(r) ?? false;
    if (needApproveAlt && !altDisabled) {
      return { label: this.translate.instant('APPROVE_AND_VALIDATE'), disabled: false, action: 'approve_then_validate' };
    }

    // 6) OK → Validate (sinon disabled avec raisons)
    return {
      label: this.translate.instant('VALIDATE'),
      disabled: altDisabled,
      action: altDisabled ? null : 'validate',
      reasons
    };
  }



  // 🔽 utilitaires internes
  private toWei(v: any): bigint {
    try {
      if (typeof v === 'bigint') return v;
      if (typeof v === 'number') return BigInt(Math.trunc(v));
      if (typeof v === 'string') return v.startsWith('0x') ? BigInt(v) : BigInt(v || '0');
    } catch { }
    return 0n;
  }
  private formatNative(nWei: bigint, cid?: number): string {
    const sym = this.getNativeTokenSymbol ? this.getNativeTokenSymbol(Number(cid ?? this.chainId ?? 1)) : 'ETH';
    const eth = Number(nWei) / 1e18;
    // 0.000000 syntax propre
    const pretty = eth >= 1 ? eth.toFixed(6).replace(/\.?0+$/, '') :
      eth >= 0.01 ? eth.toFixed(6).replace(/\.?0+$/, '') :
        eth.toFixed(8).replace(/\.?0+$/, '');
    return `${pretty} ${sym}`;
  }
  private formatFiatFromWei(nWei: bigint): string {
    const usd = (Number(nWei) / 1e18) * (this.gasFeePriceUSD ?? 0); // prix USD du natif
    const rate = this.fiatRates?.[this.selectedCurrency] ?? 1;      // ex: EUR
    const v = usd * rate;
    // < 1 → 2 décimales, sinon 2
    const pretty = v < 1 ? v.toFixed(2) : v.toFixed(2);
    return `${pretty} ${this.selectedCurrency}`;
  }

  private pickRouteFullGasWei(r?: any): bigint {
    const toWei = (v: any): bigint => {
      try {
        if (typeof v === 'bigint') return v;
        if (typeof v === 'number') return BigInt(Math.trunc(v));
        if (typeof v === 'string') return v.startsWith('0x') ? BigInt(v) : BigInt(v || '0');
      } catch { }
      return 0n;
    };

    // Fallback si pas de route
    if (!r) return toWei(this.fullGasWei ?? 0);

    // 0) LiFi network fee natif (source officielle LiFi) — PRIORITAIRE
    const lifiNet = toWei(r?.lifiNetworkFeeWei);
    if (lifiNet > 0n) return lifiNet;

    // 1) Estimation wallet / MetaMask (moins fiable, souvent gonflée)
    const mm = toWei(r?.mmMaxNetworkFeeWei ?? r?.mmNetworkFeeWei ?? r?.gas?.fullWei);
    if (mm > 0n) return mm;

    // 2) LiFi: amount direct si fourni
    const lifiAmount = toWei(r?.lifiGasAmountWei);
    if (lifiAmount > 0n) return lifiAmount;

    // 3) LiFi: recalcul price * gas
    const p = Number(r?.lifiGasPriceWei), g = Number(r?.lifiEstimatedGas);
    if (p && g) return BigInt(Math.round(p * g));

    // 4) Fallback global
    return toWei(this.fullGasWei ?? 0);
  }


  // 🔽 déficit pour la quote principale
  getMainGasDeficitText(): { native: string; fiat: string } | null {
    if (!this.bridgeReasons?.includes('INSUFFICIENT_NATIVE_GAS')) return null;
    const need = this.pickRouteFullGasWei(this.quote);
    const have = this.toWei(this.nativeBalanceWei ?? 0);
    const missing = need > have ? (need - have) : 0n;
    if (missing <= 0n) return null;
    return {
      native: this.formatNative(missing, this.chainId ?? 1),
      fiat: this.formatFiatFromWei(missing)
    };
  }



    // --- ÉTAT TOOLTIP (même logique que Quote V4)
  openedTooltip: string | null = null;
    private makeTooltipKey(topic: 'slippage' | 'price_impact' | 'network_fees' | 'bridge_fees' | 'estimated_time', scope ?: string): string {
      return scope ? `${topic}:${scope}` : topic;
    }
  toggleTooltip(
      topic: 'slippage' | 'price_impact' | 'network_fees' | 'bridge_fees' | 'estimated_time',
      scope ?: string,
      ev ?: MouseEvent
      ): void {
    if (ev) ev.stopPropagation();
    const key = this.makeTooltipKey(topic, scope);
    this.openedTooltip = (this.openedTooltip === key) ? null : key;
  }
  closeTooltip(): void { this.openedTooltip = null; }
   getHelpUrl(topic: 'slippage' | 'price_impact' | 'network_fees' | 'bridge_fees' | 'estimated_time'): string {
  const lang = (this as any).translate?.currentLang?.toLowerCase?.() || 'en';
  return `/${lang}/blog/${this.helpSlugs[topic]}`;
}
  private helpSlugs: Record<'slippage' | 'price_impact' | 'network_fees' | 'bridge_fees' | 'estimated_time', string> = {
    slippage: 'slippage-crypto-explication',
      price_impact: 'price-impact-crypto-explication',
    network_fees: 'frais-reseau-crypto-explication',
    bridge_fees: 'frais-bridge-crypto-explication',
    estimated_time: 'duree-bridge-crypto-explication'
        };


    // Fermer au clic à l’extérieur
    @HostListener('document:click', ['$event'])
   onDocClick(e: MouseEvent): void {
    if (!this.openedTooltip) return;
    const target = e.target as Node;
    if (!(this as any)?.['el']?.nativeElement?.contains?.(target)) {
        this.closeTooltip();
      }
  }
  // Fermer avec Échap
    @HostListener('document:keydown.escape')
   onEsc(): void { this.closeTooltip(); }















  // 🔽 déficit pour une alternative
  getAltGasDeficitText(r: any): { native: string; fiat: string } | null {
    // raisons (cohérentes avec le cache/clé)
    const reasons: string[] = this.getAltReasons(r);
    if (!reasons.includes('INSUFFICIENT_NATIVE_GAS')) return null;

    const need = this.pickRouteGatingWei(r);
    const have = this.toWei(this.nativeBalanceWei ?? 0);
    const missing = need > have ? (need - have) : 0n;
    if (missing <= 0n) return null;

    return {
      native: this.formatNative(missing, this.chainId ?? 1),
      fiat: this.formatFiatFromWei(missing),
    };
  }

  getAltGasBadge(r: any): 'ok' | 'low' {
    const need = this.pickRouteGatingWei(r);
    const have = this.toWei(this.nativeBalanceWei ?? 0);
    return have >= need ? 'ok' : 'low';
  }
  // 🔽 Texte "Network fee" (natifs + fiat), LiFi-first
  getAltNetworkFeeText(r: any): { native: string; fiat: string } {
    // Native (wei → ETH) basé sur pickRouteFullGasWei en mode LiFi-first
    const wei = this.pickRouteFullGasWei(r);
    const native = Number(wei) / 1e18;

    // Symbole (gas token de la route ou symbole natif de la chaîne)
    const symbol =
      r?.gasTokenSymbol ||
      this.getNativeTokenSymbol?.(Number(this.chainId ?? 1)) ||
      'ETH';

    // Fiat: utiliser l'USD LiFi si dispo; sinon calculer avec gasFeePriceUSD
    const usdFromLiFi = (r?.lifiGasFeeUsd != null) ? Number(r.lifiGasFeeUsd) : null;
    const usd = (usdFromLiFi != null)
      ? usdFromLiFi
      : (this.gasFeePriceUSD ? native * this.gasFeePriceUSD : null);

    const rate = this.fiatRates?.[this.selectedCurrency?.toUpperCase?.()] ?? 1;

    return {
      native: `${this.toFixedSmart(native)} ${symbol}`,
      fiat: (usd != null)
        ? new Intl.NumberFormat(undefined, { style: 'currency', currency: this.selectedCurrency || 'EUR' }).format(usd * rate)
        : '—'
    };
  }

  // ===== UI state =====
  showMainDetails = false;
  expandedAlt: Record<number, boolean> = {};

  // Gating calculé (principal)
  bridgeDisabled = false;
  bridgeReasons: string[] = [];
  showAlternatives: boolean = false;

  // Gating spécifique par alternative (cache)
  private altGatingCache: Map<string, { disabled: boolean; reasons: string[] }> = new Map();

  // ⬇️ DI du validator
  private balanceValidator = inject(BalanceValidatorService);

  // ---------------- Lifecycle ----------------
  ngOnChanges(_: SimpleChanges): void {
    this.computeMainGating();
    // Invalider le cache alt si inputs critiques changent
    this.altGatingCache.clear();
    this._computedOtherRoutes = this.computeOtherRoutes();
        // 1) on mémorise la signature de route (utile pour d’autres logiques)
          const routeSig = this.buildRouteSignature();
        this.lastRouteSig = routeSig;
    
          // 2) relancer l’affichage inline 4s si *l’un* de ces éléments change :
          //    - connexion wallet, - état disabled, - contenu des raisons, - routes alternatives calculées
          const inlineKey = JSON.stringify({
              routeSig,
              connected: this.isWalletConnected(),
              disabled: this.bridgeDisabled,
              reasons: (this.bridgeReasons ?? []).join('|'),
              altsLen: this._computedOtherRoutes?.length ?? 0,
            });
    if (inlineKey !== this.lastInlineKey) {
        this.lastInlineKey = inlineKey;
        this.scheduleInlineWhyTimeouts();
      }


    setTimeout(() => this.updateStickyFooter(), 0);
      // 🔒 Post-traitement ultra-léger des erreurs entrantes (aucun refacto)
        if (this.bridgeStatus === 'error' && this.bridgeError != null) {
            // 1) Annulation utilisateur → transformer en 'cancelled' immédiatement
              if (this.isUserCancelled(this.bridgeError)) {
                  this.bridgeStatus = 'cancelled';
                  this.bridgeError = null;
                } else {
                // 2) Jamais de message brut : hex/calldata ou JSON verbeux → générique
                  const s = String(
                      (typeof this.bridgeError === 'string' && this.bridgeError) ||
                      (this as any).bridgeError?.reason ||
                      (this as any).bridgeError?.shortMessage ||
                      (this as any).bridgeError?.error?.message ||
                      (this as any).bridgeError?.message || ''
                    );
                const looksHex = /^0x[0-9a-fA-F]{24,}$/.test(s.trim());
                const looksJsonDump = s.includes('{') || s.includes('}') || s.length > 160;
                if (looksHex || looksJsonDump) {
                   this.bridgeError = 'ERROR_SWAP_GENERIC'; // sera formaté côté UI en “Erreur durant le swap.”
                  }
              }
          }
  }
  ngAfterViewInit(): void {
      // après montage : mesures DOM + affichage des alertes inline 4s
        setTimeout(() => {
            this.updateStickyFooter();
            this.scheduleInlineWhyTimeouts();
          }, 0);
  }
  ngOnDestroy(): void {
    this.showStickyFooter = false;
  }
  @HostListener('window:resize')

  onResize() {
    this.updateStickyFooter();
  }
  toggleMainDetails(): void {
    this.showMainDetails = !this.showMainDetails;
    setTimeout(() => this.updateStickyFooter(), 0);
  }

  toggleAlternatives(): void {
    this.showAlternatives = !this.showAlternatives;
    setTimeout(() => this.updateStickyFooter(), 0);
  }
  /** Statut à afficher pour l’alternative i (scopé) */
  getAltStatusFor(i: number): 'idle' | 'approving' | 'pending' | 'success' | 'cancelled' | 'error' {
    return (this.lastAltStatusIndex === i && this.expandedAltIndex === i) ? (this.statusNorm as any) : 'idle';
  }

  toggleAlt(i: number) {
    if (this.expandedAltIndex === i) {
      // Fermer la carte i
      this.expandedAltIndex = null;
      this.expandedAlt[i] = false;

      // Reset complet des statuts/messages
      this.bridgeStatus = 'idle';
      this.bridgeError = null;
      this.bridgeHash = null;
      this.lastAltStatusIndex = null;

    } else {
      // Ouvrir la carte i (fermer l’ancienne si besoin)
      if (this.expandedAltIndex != null) {
        this.expandedAlt[this.expandedAltIndex] = false;
      }
      this.expandedAltIndex = i;
      this.expandedAlt[i] = true;

      // Reset des statuts quand on ouvre une nouvelle carte
      this.bridgeStatus = 'idle';
      this.bridgeError = null;
      this.bridgeHash = null;
      this.lastAltStatusIndex = null;

      // Scroll doux vers la carte ouverte
      setTimeout(() => {
        const host = this.scrollArea?.nativeElement;
        const cards = host?.querySelectorAll('[data-alt-card]') as NodeListOf<HTMLElement>;
        const el = cards && cards[i];
        if (el && host) {
          const top = el.offsetTop - 8;
          host.scrollTo({ top, behavior: 'smooth' });
        }
      }, 0);
    }

    setTimeout(() => this.updateStickyFooter(), 0);
  }


  // ——— Sticky footer logic ———
  private updateStickyFooter(): void {
    const el = this.altScrollArea?.nativeElement || this.scrollArea?.nativeElement;
    const expandedAltMap = (this as any).expandedAlt || {};
    const anyAltOpen = Object.values(expandedAltMap).some(Boolean);

    this.isExpanded = !!(this._showMainDetails || this.showAlternatives || anyAltOpen);

    if (!el) {
      this.showStickyFooter = false;
      return;
    }
    // petite tolérance pour densités/zoom iOS
    const scrollable = el.scrollHeight > el.clientHeight + 2;
    this.showStickyFooter = this.isExpanded && scrollable;
  }

  // ——— Helpers résumé header ———
  private _fmtNum(v: number): string {
    if (!Number.isFinite(v)) return '0';
    const s = (v >= 1 ? v.toFixed(6) : v.toFixed(6)).replace(/\.?0+$/, '');
    return s || '0';
  }
  private _label(sym?: string | null): string {
    const s = String(sym || '').toUpperCase();
    const get = (this as any)?.getTokenLabel;
    return typeof get === 'function' ? get(s) : s;
  }
  private _netName(cid?: number | null): string {
    const get = (this as any)?.getNetworkName;
    if (typeof get === 'function') return get(Number(cid ?? 1));
    const map: Record<number, string> = { 1: 'Ethereum', 10: 'Optimism', 56: 'BNB Chain', 137: 'Polygon', 42161: 'Arbitrum', 8453: 'Base' };
    return map[Number(cid ?? 1)] || 'Ethereum';
  }
  private _num(v: any): number {
    if (typeof v === 'bigint') return Number(v);
    if (typeof v === 'string' && v.startsWith('0x')) { try { return Number(BigInt(v)); } catch { return NaN; } }
    const n = Number(v); return isFinite(n) ? n : NaN;
  }
  private _normAmount(raw: any, decimals: number): number {
    const n = this._num(raw);
    if (!isFinite(n) || decimals == null) return 0;
    return n / Math.pow(10, decimals || 18);
  }
  private _formattedSellAmount(): string {
    const q: any = this.quote || {};
    const dec = Number(q?.fromTokenDecimals ?? q?.fromToken?.decimals ?? 18);
    let v = Number(q?.inputAmountFormatted);
    if (!(v > 0)) {
      const raw = q?.fromAmountRaw ?? q?.fromAmount;
      v = this._normAmount(raw, dec);
    }
    return this._fmtNum(v);
  }
  private _formattedBuyAmount(): string | null {
    const q: any = this.quote || {};
    const dec = Number(q?.toTokenDecimals ?? q?.toToken?.decimals ?? 18);
    let v = Number(q?.outputAmountFormatted ?? q?.estimatedBuyAmount);
    if (!(v > 0)) {
      const raw = q?.toAmountRaw ?? q?.toAmount;
      if (raw == null) return null;
      v = this._normAmount(raw, dec);
    }
    if (!(v > 0)) return null;
    return this._fmtNum(v);
  }
  getBridgeSummaryLine(): string {
    const q: any = this.quote || {};

    // Montant + symbole vendu
    const sellAmt = this._formattedSellAmount();
    const sellSym = this._label(
      q?.sellSymbol || q?.fromTokenSymbol || q?.fromToken?.symbol
    );
    const fromNet = this._netName(Number(q?.fromChainId));

    // Montant + symbole acheté
    const buyAmt = this._formattedBuyAmount();
    const buySym = this._label(
      q?.buySymbol || q?.toTokenSymbol || q?.toToken?.symbol
    );
    const toNet = this._netName(Number(q?.toChainId));

    // Parties distinctes
    const left = `${sellAmt} ${sellSym} · ${fromNet}`;
    const right = `${buyAmt != null ? buyAmt + ' ' : ''}${buySym} · ${toNet}`;

    // ✅ Version multilignes (mobile-friendly)
    // Utilise un retour à la ligne explicite que tu pourras rendre effectif avec CSS `white-space: pre-line;`
    return `${left}\n→ ${right}`;
  }

  // Normalisation statut pour l’affichage/logic interne si besoin
  get statusNorm(): 'idle' | 'approving' | 'pending' | 'success' | 'cancelled' | 'error' | null {
    return this.bridgeStatus === 'approve' ? 'approving' : (this.bridgeStatus ?? 'idle');
  }
  private pickRouteGatingWei(r: any): bigint {
  const toWei = (v: any) => {
    try {
      if (typeof v === 'bigint') return v;
      if (typeof v === 'number') return BigInt(Math.trunc(v));
      if (typeof v === 'string') return v.startsWith('0x') ? BigInt(v) : BigInt(v || '0');
    } catch {}
    return 0n;
  };
  // ✅ expected d'abord (et ce qu’on t’a mis dans r.gas.fullWei = expected)
  const expected = toWei(r?.mmExpectedNetworkFeeWei ?? r?.gas?.fullWei);
  if (expected > 0n) return expected;

  // fallback “MM normal”, puis max si c’est tout ce qu’on a
  const mm = toWei(r?.mmNetworkFeeWei);
  if (mm > 0n) return mm;

  // dernier filet (éviter de basculer sur LiFi pour le gating)
  return toWei(r?.mmMaxNetworkFeeWei) || 0n;
}

  // ---------------- Gating (MAIN) ----------------
  private computeMainGating(): void {
    try {
      const res = this.balanceValidator.isBridgeDisabled({
        takerAddress: this.takerAddress ?? null,                          // OK: string | null
        fromChainId: (this.chainId ?? 1) as number, // number

        // ❗️ces champs doivent être non-nuls pour matcher le service
        sellTokenSymbol: this.sellTokenSymbol ?? '',                      // string
        sellAmount: (this.sellAmount ?? 0) as number,                     // string | number
        fullGasWei: (this.fullGasWei ?? 0) as string | number | bigint,   // string | number | bigint

        // ❗️collections non-null
        availableSellTokens: (this.availableSellTokens ?? []) as any,     // TokenLite[]
        sellTokenBalances: (this.sellTokenBalances ?? {}) as Record<string, string | number>,

        // fonction toujours définie
        getNativeTokenSymbol: (cid: number) =>
          this.getNativeTokenSymbol ? this.getNativeTokenSymbol(cid) : 'ETH',

        // marge par défaut identique à V1
        marginPct: 0.05,
      });

      this.bridgeReasons = Array.isArray(res?.reasons) ? res.reasons : [];
      this.bridgeReasons = this.stripGasIfBypassed(this.bridgeReasons);

      // disabled = true seulement s’il reste d’autres raisons bloquantes
      this.bridgeDisabled = this.bridgeReasons.length > 0;
    } catch {
      // fallback ultra-minimal si le service throw
      const reasons: string[] = [];
      if (!this.takerAddress) reasons.push('WALLET_NOT_CONNECTED');
      const amt = Number(this.sellAmount ?? 0);
      if (!amt || amt <= 0) reasons.push('INVALID_AMOUNT');
      this.bridgeReasons = reasons;
      this.bridgeDisabled = reasons.length > 0;
    }
  }

  // ---------------- Buttons states (ALTERNATIVES UI + gating alt) ----------------
  isAltValidateDisabled(r: any): boolean {
    // 1) gèle pendant approve/pending
    if (this.statusNorm === 'approving' || this.statusNorm === 'pending') return true;

    // 2) blocages globaux
    if (this.bridgeReasons.includes('WALLET_NOT_CONNECTED')
      || this.bridgeReasons.includes('WALLET_DISCONNECTED')
      || this.bridgeReasons.includes('INVALID_AMOUNT')) return true;

    // 3) décision par route (cache)
    const key = this.altKey(r);
    const hit = this.altGatingCache.get(key);
    if (hit) return hit.disabled;

    // était : const routeFullWei = this.pickRouteFullGasWei(r);
    const routeFullWei = this.pickRouteGatingWei(r);


    const res = this.balanceValidator.isBridgeDisabled({
      takerAddress: this.takerAddress ?? null,
      fromChainId: Number(this.chainId ?? 1),
      sellTokenSymbol: (this.sellTokenSymbol ?? '').toUpperCase(),
      sellAmount: (this.sellAmount ?? 0) as number,
      fullGasWei: routeFullWei, // ✅ plafond exact de CETTE route
      availableSellTokens: (this.availableSellTokens ?? []) as any,
      sellTokenBalances: (this.sellTokenBalances ?? {}) as Record<string, string | number>,
      getNativeTokenSymbol: (cid: number) => this.getNativeTokenSymbol ? this.getNativeTokenSymbol(cid) : 'ETH',
      marginPct: 0.05,
    });

    const out = { disabled: !!res?.disabled, reasons: res?.reasons ?? [] };

    // 👇 bypass = on retire la raison gas et on recalcule disabled
    out.reasons = this.stripGasIfBypassed(out.reasons);
    out.disabled = out.reasons.length > 0;

    this.altGatingCache.set(key, out);
    return out.disabled;

  }


  private ensureAltGating(r: BridgeQuoteLike): void {
    const key = JSON.stringify({
      to: r.to,
      data: r.data,
      fromChainId: this.chainId ?? 1,
      amount: this.sellAmount,
      symbol: this.sellTokenSymbol,
    });
    if (this.altGatingCache.has(key)) return;

    const liFiWei =
      r.lifiGasAmountWei ??
      ((r.lifiGasPriceWei != null && r.lifiEstimatedGas != null)
        ? Number(r.lifiGasPriceWei) * Number(r.lifiEstimatedGas)
        : undefined);

    const fullGasWeiAlt = (liFiWei ?? this.fullGasWei ?? 0) as string | number | bigint;

    const res = this.balanceValidator.isBridgeDisabled({
      takerAddress: this.takerAddress ?? null,
      fromChainId: (this.chainId ?? 1) as number,
      sellTokenSymbol: this.sellTokenSymbol ?? '',
      sellAmount: (this.sellAmount ?? 0) as number,
      fullGasWei: fullGasWeiAlt,
      availableSellTokens: (this.availableSellTokens ?? []) as any,
      sellTokenBalances: (this.sellTokenBalances ?? {}) as Record<string, string | number>,
      getNativeTokenSymbol: (cid: number) =>
        this.getNativeTokenSymbol ? this.getNativeTokenSymbol(cid) : 'ETH',
      marginPct: 0.05,
    });

    this.altGatingCache.set(key, { disabled: res.disabled, reasons: res.reasons });
  }

  private altKey(r: any): string {
    const routeFullWei = this.pickRouteFullGasWei(r);
    const txr: any = r?.transactionRequest;
    return JSON.stringify({
      to: r?.to ?? null,
      data: r?.data ?? null,
      txr_to: txr?.to ?? null,
      txr_data: txr?.data ?? null,
      cid: this.chainId ?? 1,
      amt: this.sellAmount ?? 0,
      sym: (this.sellTokenSymbol ?? '').toUpperCase(),
      routeFullWei: routeFullWei.toString(),                // 👈 nouveau
      nativeBal: (this.nativeBalanceWei ?? 0).toString(),   // 👈 nouveau
    });
  }


  getAltReasons(r: any): string[] {
    const key = this.altKey(r);
    const hit = this.altGatingCache.get(key);
    if (hit) return hit.reasons ?? [];
    // Assure le remplissage du cache
    void this.isAltValidateDisabled(r);
    return this.altGatingCache.get(key)?.reasons ?? [];
  }





  // --- Sell amount (normalise toutes variantes) ---
  private pickSellAmount(x: any): number | null {
    return (
      this.toNumSoft(x?.inputAmountFormatted) ??
      this.toNumSoft(x?.fromAmount) ??
      this.fromRaw(x?.inputAmountRaw, x?.fromTokenDecimals) ??
      null
    );
  }

  // --- Bridge fee en USD (top-level ou route sélectionnée) ---
  private pickBridgeFeeUsd(x: any): number | null {
    return (
      this.toNumSoft(x?.bridgeFeeUsd) ??
      this.toNumSoft(x?.singleRoutes?.[0]?.bridgeFeeUsd) ??
      this.toNumSoft(x?.SingleRoutes?.[0]?.bridgeFeeUsd) ??
      null
    );
  }

  // --- Network fee en natif (ETH/POL/...) puis conversion possible via gasFeePriceUSD ---
  private pickGasNative(x: any): number {
    // V1 main: gasFeeValue (déjà en natif)
    const v1 = this.toNumSoft(x?.gasFeeValue);
    if (v1 !== null) return v1;

    // Fallback LiFi: gasAmountWei OU (gasPriceWei * estimatedGas)
    const wei = this.pickWei(x);
    return wei ? Number(wei) / 1e18 : 0;
  }

  // --- Price impact (%) fourni par provider si présent ---
  private pickProvidedPriceImpactPct(x: any): number | null {
    const v =
      this.toNumSoft(x?.priceImpactPct) ??
      this.toNumSoft(x?.route?.priceImpactPct) ??
      this.toNumSoft(x?.steps?.[0]?.priceImpactPct);
    return v;
  }

  // --- Calcul principal : renvoie un pourcentage (ex: -0.73) ou null ---
  computePriceImpactPctSwapStyle(q: any): number | null {
    const sell = this.pickSellAmount(q);        // ex: inputAmountFormatted / fromAmountRaw+dec
    const buy = this.pickBuyAmount(q);         // ex: outputAmountFormatted / toAmountRaw+dec
    const sellUsd = this.toNumSoft(q?.sellTokenUsdPrice) ?? this.toNumSoft(this.inTokenPriceUSD);
    const buyUsd = this.toNumSoft(q?.buyTokenUsdPrice) ?? this.toNumSoft(this.outTokenPriceUSD);
    if (!sell || !buy || !sellUsd || !buyUsd) return null;

    let fairBuy = (sell * sellUsd) / buyUsd;
    const integFeeUsd = this.toNumSoft(q?.integratorFeeUsd);
    if (integFeeUsd && integFeeUsd > 0) {
      const adj = ((sell * sellUsd) - integFeeUsd) / buyUsd;
      if (adj > 0 && Number.isFinite(adj)) fairBuy = adj;
    }
    if (!(fairBuy > 0)) return null;

    const impact = Math.max(0, 1 - (buy / fairBuy)) * 100;
    return Number.isFinite(impact) ? impact : null;
  }

  getPriceImpactPct(q: any): string {
    const v = this.computePriceImpactPctSwapStyle(q);
    return v == null ? '—' : `${v.toFixed(v >= 1 ? 2 : 3)}%`;
  }

  // en haut du composant (ou juste avant la méthode)
  private readonly DEBUG_PI = true;
  private logPI(...a: any[]) { if (this.DEBUG_PI) console.log('[PI-alt]', ...a); }

  // Helper local (optionnel) : récupère la part intégrateur en USD depuis la quote parent
  private pickIntegratorFeeUsdFromParent_LiFi(): number {
    const Q: any = (this as any).quote ?? {};
    const fees = Q?.rawJson?.estimate?.feeCosts;
    if (!Array.isArray(fees)) return 0;

    for (const f of fees) {
      const amountUsd = Number(f?.amountUSD ?? 0);
      if (!(amountUsd > 0)) continue;

      const split = f?.feeSplit?.integratorFee;
      if (split != null) {
        const part = amountUsd * Number(split);
        if (part > 0 && Number.isFinite(part)) return part;
      }

      const name = String(f?.name || f?.title || '').toLowerCase();
      if (name.includes('fixed')) {
        // fallback conservateur si pas de split explicite
        return amountUsd;
      }
    }
    return 0;
  }


  // Affiche l'impact prix pour une alternative.
  // Cas général : si la quote parente n'a pas rawJson.estimate.fromAmountUSD,
  // on reconstruit fromUsd = sell × inTokenPriceUSD (et toUsd si besoin).
  getRoutePriceImpact(r: any): string {
    const Q: any = (this as any).quote ?? {};
    const R: any = r ?? {};

    const toNum = (v: any) => {
      const n = Number(v);
      return Number.isFinite(n) ? n : NaN;
    };

    // --- SELL (parent) ---
    const fromDec = toNum(Q?.fromToken?.decimals ?? Q?.sellTokenDecimals ?? 18);
    // quantité vendue (tokens)
    let sell = toNum(Q?.inputAmountFormatted);
    if (!Number.isFinite(sell)) {
      const raw = toNum(Q?.rawJson?.estimate?.fromAmount ?? Q?.inputAmountRaw);
      if (Number.isFinite(raw) && Number.isFinite(fromDec)) sell = raw / Math.pow(10, fromDec);
    }

    // --- BUY (alt) ---
    const toDec = toNum(R?.toTokenDecimals ?? R?.toToken?.decimals ?? Q?.toToken?.decimals ?? 18);
    const toAmountRaw = toNum(R?.toAmountRaw);
    let buy = Number.isFinite(toAmountRaw) && Number.isFinite(toDec) ? toAmountRaw / Math.pow(10, toDec) : NaN;

    // Garde: il faut des quantités token valides
    if (!Number.isFinite(sell) || sell <= 0 || !Number.isFinite(buy) || buy <= 0) return '—';

    // --- USD (si dispo via LiFi) ---
    let fromUsd = toNum(Q?.rawJson?.estimate?.fromAmountUSD);
    let toUsd = toNum(R?.toAmountUsd);

    // --- Prices USD connus sur le composant (parent fournit déjà ces valeurs) ---
    // Accepte plusieurs alias pour éviter les régressions de naming.
    const inPriceUsd =
      toNum((this as any).inTokenPriceUSD) ??
      toNum((this as any).sellTokenPriceUSD) ??
      toNum(Q?.rawJson?.estimate?.fromToken?.priceUSD);

    const outPriceUsd =
      toNum((this as any).outTokenPriceUSD) ??
      toNum((this as any).buyTokenPriceUSD) ??
      toNum(Q?.rawJson?.estimate?.toToken?.priceUSD);

    // Si fromUsd manquant (cas vu dans tes logs): reconstruit avec inPriceUsd
    if (!(fromUsd > 0) && Number.isFinite(inPriceUsd) && inPriceUsd > 0) {
      fromUsd = sell * inPriceUsd;
    }
    // Si toUsd manquant côté alt: reconstruit avec outPriceUsd
    if (!(toUsd > 0) && Number.isFinite(outPriceUsd) && outPriceUsd > 0) {
      toUsd = buy * outPriceUsd;
    }

    // 1) Chemin simple et robuste: ratio USD
    if (fromUsd > 0 && toUsd > 0) {
      const pct = Math.max(0, 1 - (toUsd / fromUsd)) * 100;
      return `${(pct >= 1 ? pct.toFixed(2) : pct.toFixed(3))}%`;
    }

    // 2) Sinon, tente chemin "token prices" si dispo (rare quand estimate manque)
    const sellUsd = Number.isFinite(inPriceUsd) && inPriceUsd > 0 ? inPriceUsd : toNum(Q?.rawJson?.estimate?.fromToken?.priceUSD);
    const buyUsd = Number.isFinite(outPriceUsd) && outPriceUsd > 0 ? outPriceUsd : toNum(Q?.rawJson?.estimate?.toToken?.priceUSD);

    if (sellUsd > 0 && buyUsd > 0) {
      const fairBuy = (sell * sellUsd) / buyUsd;
      if (Number.isFinite(fairBuy) && fairBuy > 0) {
        const pct = Math.max(0, 1 - (buy / fairBuy)) * 100;
        return `${(pct >= 1 ? pct.toFixed(2) : pct.toFixed(3))}%`;
      }
    }

    // Si on n'a toujours pas assez d'info, on reste safe
    return '—';
  }






  getRateText(r?: any): string {
    // Pas de données → rien à afficher
    if (!r && !this.quote) return '—';

    // 🔹 Symboles : rester dans le contrat BridgeQuoteLike + @Input
    const sellSym =
      (this.sellTokenSymbol ?? this.quote?.sellSymbol ?? '').toString();
    const buySym = (this.pickBuySymbol(r || this.quote) || '').toString();

    if (!sellSym || !buySym) return '—';

    // 1) Si la route fournit un rate direct → on l’utilise
    const direct = this.toNumSoft(r?.rate);
    if (direct !== null && isFinite(direct) && direct > 0) {
      return `1 ${sellSym} = ${this.toFixedSmart(direct)} ${buySym}`;
    }

    // 2) Sinon, on calcule : OUT / IN en s'appuyant sur les helpers bridge
    const inAmt = this.pickSellAmount(this.quote);       // montant vendu (parent)
    const outAmt = this.pickBuyAmount(r || this.quote);   // montant reçu (route ou parent)

    if (!(inAmt && outAmt) || inAmt <= 0 || outAmt <= 0) return '—';

    const rate = outAmt / inAmt;
    if (!isFinite(rate) || rate <= 0) return '—';

    return `1 ${sellSym} = ${this.toFixedSmart(rate)} ${buySym}`;
  }




  toFixedSmart(v: number, max = 6): string {
    if (!Number.isFinite(v)) return '';
    if (v === 0) return '0';
    const s = v.toFixed(max);
    return parseFloat(s).toString();
  }

  asFiat(n?: number | null): string {
    if (!Number.isFinite(n as number)) return '—';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: this.selectedCurrency || 'EUR'
      }).format(n as number);
    } catch {
      return `${n} ${this.selectedCurrency || 'EUR'}`;
    }
  }

  secondsToText(sec?: number | null): string {
    if (!sec && sec !== 0) return '—';
    if ((sec as number) < 60) return `${sec}s`;
    const m = Math.floor((sec as number) / 60);
    const s = (sec as number) % 60;
    return s ? `${m}m ${s}s` : `${m}m`;
  }

  // V1/V2: estimated time helper (regroupe toutes les variantes possibles)
  getEstimatedTimeSec(x: any): number | null {
    const toNum = (v: any) => (v === undefined || v === null ? null : Number(v));
    return (
      toNum(x?.estimatedServiceTimeSec) ??     // V1 main / alt
      toNum(x?.estimatedDurationSeconds) ??    // V2 / LiFi
      toNum(x?.estimatedTimeSec) ??            // éventuel alias
      null
    );
  }

  // ---------------- Fees helpers (brancher tes vrais getters) ----------------
  getMainNetworkFeeText(): { native: string; fiat: string } {
    // V1: gasFeeValue en natif (ETH, etc.)
    const nativeAmt = this.toNumSoft((this.quote as any)?.gasFeeValue);
    const symbol = (this.quote as any)?.gasFeeSymbol || this.quote?.gasTokenSymbol || 'ETH';

    if (nativeAmt !== null) {
      const fiatUsd = this.gasFeePriceUSD ? nativeAmt * this.gasFeePriceUSD : null;
      const rate = this.fiatRates?.[this.selectedCurrency.toUpperCase()] ?? 1;
      return {
        native: `${this.formatCryptoTerse(nativeAmt)} ${symbol}`,
        fiat: fiatUsd != null ? new Intl
          .NumberFormat(undefined, { style: 'currency', currency: this.selectedCurrency })
          .format(fiatUsd * rate) : '—'
      };
    }

    // sinon: fallback LiFi (amountWei ou price*estimate)
    const wei = this.pickWei(this.quote);
    const eth = wei ? Number(wei) / 1e18 : 0;
    const rate = this.fiatRates?.[this.selectedCurrency.toUpperCase()] ?? 1;
    const usd = this.gasFeePriceUSD ? eth * this.gasFeePriceUSD : null;
    return {
      native: `${this.toFixedSmart(eth)} ${symbol}`,
      fiat: usd != null ? new Intl.NumberFormat(undefined, { style: 'currency', currency: this.selectedCurrency }).format(usd * rate) : '—'
    };
  }

  getMaxSlippagePct(q: any): string {
    const pct = this.toNumSoft(q?.maxSlippagePct);
    if (pct !== null) return `${pct.toFixed(2)}%`;
    const bps = this.toNumSoft(q?.slippageBps) ?? 100; // V1 default
    return `${(bps / 100).toFixed(2)}%`;
  }

  getMainBridgeFeeText(): string {
    const direct = this.toNumSoft((this.quote as any)?.bridgeFeeUsd);
    const fromAlt = this.toNumSoft((this.quote as any)?.singleRoutes?.[0]?.bridgeFeeUsd
      ?? (this.quote as any)?.SingleRoutes?.[0]?.bridgeFeeUsd);
    const usd = direct ?? fromAlt ?? null;
    if (usd === null) return '—';
    const rate = this.fiatRates?.[this.selectedCurrency.toUpperCase()] ?? 1;
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: this.selectedCurrency }).format(usd * rate);
  }

  // Nouvelle méthode pour vérifier l'état du mode
  isDarkMode(): boolean {
    return document.body.classList.contains('dark-mode');
  }

  private pickWei(x?: BridgeQuoteLike | null): number {
    // Préfère un total direct si dispo
    const a = Number(x?.lifiGasAmountWei || 0);
    if (a) return a;
    const p = Number(x?.lifiGasPriceWei || 0);
    const g = Number(x?.lifiEstimatedGas || 0);
    return p && g ? p * g : 0;
    // TIP: remplace par ta logique unifiée (ex: getRouteDisplayedGasFee)
  }

  private fakeNativeToFiat(native: number): number {
    // Placeholder: branche ton nativeTokenPriceService * native
    const approxPrice = 2500; // TEMP pour dev — remplace par le prix natif réel
    return native * approxPrice;
  }

  // Nom du provider (main + legacy + LiFi)
  getProviderName(item?: any): string {
    const x = item ?? this.quote;
    return (
      x?.provider ||
      x?.providerName ||
      x?.providerKey ||
      x?.bridgeName ||
      x?.toolDetails?.name ||
      '—'
    );
  }

  // Logo du provider (main + legacy + LiFi)
  getProviderLogo(item?: any): string | null {
    const x = item ?? this.quote;

    // 1) champs “modernes”
    const direct =
      x?.providerLogo ||
      x?.providerLogoUrl ||
      x?.logoURI ||
      null;

    if (direct) return direct;

    // 2) legacy + LiFi raw
    const legacy =
      x?.BridgeIcon ||
      x?.bridgeIcon ||
      x?.toolDetails?.logoURI ||
      null;

    if (legacy) return legacy;

    return null;
  }

  // --- Normalisation champs amount/symbol/fiat (main + legacy + LiFi) ---
  private toNumSoft(v: any): number | null {
    if (v === null || v === undefined || v === '') return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  }
  private fromRaw(raw: any, decimals: any): number | null {
    if (raw === null || raw === undefined) return null;
    const s = String(raw);
    if (!/^\d+$/.test(s)) return null; // raw décimal attendu
    const d = Number(decimals ?? 18);
    const n = Number(s) / Math.pow(10, d);
    return Number.isFinite(n) ? n : null;
  }
  private formatCryptoTerse(n: number, sig = 6): string {
    if (!Number.isFinite(n)) return '—';
    if (n === 0) return '0';
    const abs = Math.abs(n);
    const digits = Math.max(0, sig - Math.floor(Math.log10(abs)) - 1);
    const maxFrac = Math.min(8, Math.max(2, digits));
    return n.toLocaleString(undefined, { maximumFractionDigits: maxFrac });
  }

  // ---- SYMBOL
  // ---- SYMBOL
  private pickBuySymbol(x: any): string {
    const q: any = this.quote || {};
    return (
      x?.buySymbol ||
      x?.toTokenSymbol ||
      x?.toToken?.symbol ||
      x?.outputTokenSymbol ||
      x?.steps?.[0]?.estimate?.toToken?.symbol ||
      x?.steps?.[0]?.action?.toToken?.symbol ||
      this.buyTokenSymbol ||                     // ⬅️ fallback composant
      q?.toToken?.symbol || q?.toTokenSymbol ||  // ⬅️ fallback depuis la quote principale
      q?.outputTokenSymbol ||
      ''
    );
  }





  // ---- AMOUNT (token)
  // ---- AMOUNT (token)
  // ---- AMOUNT (token)
  private pickBuyAmount(x: any): number | null {
    // best guess for decimals (alt → quote → steps → default 18)
    const dec =
      this.toNumSoft(x?.toTokenDecimals) ??
      this.toNumSoft(x?.toToken?.decimals) ??
      this.toNumSoft(x?.steps?.[0]?.action?.toToken?.decimals) ??
      18;

    // normalized / pretty first
    const pretty =
      this.toNumSoft(x?.estimatedBuyAmount) ??
      this.toNumSoft(x?.outputAmountFormatted) ??
      this.toNumSoft(x?.toAmountFormatted) ??
      this.toNumSoft(x?.toAmount);
    if (pretty !== null) return pretty;

    // raw on the alt object
    const rawAlt = this.toNumSoft(x?.toAmountRaw);
    if (rawAlt !== null) return Number(rawAlt) / Math.pow(10, dec);

    // LiFi steps (values are RAW)
    const rawStep =
      this.toNumSoft(x?.steps?.[0]?.estimate?.toAmount) ??
      this.toNumSoft(x?.steps?.[0]?.estimate?.toAmountMin);
    if (rawStep !== null) return Number(rawStep) / Math.pow(10, dec);

    return null;
  }



  // ---- AMOUNT (fiat)
  private pickBuyFiat(x: any): number | null {
    // direct depuis la quote
    const direct = this.toNumSoft(x?.estimatedBuyFiat) ?? this.toNumSoft(x?.toAmountUsd);
    if (direct !== null) return direct;

    // fallback: amount * prix USD
    const amt = this.pickBuyAmount(x);
    const priceUsd =
      this.toNumSoft(x?.toTokenPriceUsd) ??
      this.toNumSoft(x?.outTokenPriceUSD) ??   // si la quote l’embarque
      this.toNumSoft(this.outTokenPriceUSD) ?? // ✅ prix USD passé par le parent (comme V1)
      null;

    if (amt !== null && priceUsd !== null) return amt * priceUsd;
    return null;
  }

  // ---- PUBLIC: textes pour le template
  getBuyAmountText(x: any): string {
    const amt = this.pickBuyAmount(x);
    const sym = this.pickBuySymbol(x);
    return amt !== null ? `${this.formatCryptoTerse(amt)} ${sym}` : '—';
  }
  getBuyFiatText(x: any): string {
    const usd = this.pickBuyFiat(x);
    if (usd === null) return '—';
    // conversion USD -> devise sélectionnée via fiatRates (comme ailleurs)
    const rate = this.fiatRates?.[this.selectedCurrency.toUpperCase()] ?? 1;
    const val = usd * rate;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: this.selectedCurrency || 'EUR' }).format(val);
    } catch {
      return `${val.toFixed(2)} ${this.selectedCurrency || 'EUR'}`;
    }
  }

  // Prix de change USD -> devise (EUR, etc.)
  private usdToSelectedFiat(usd: number | null): string {
    if (usd == null) return '—';
    const rate = this.fiatRates?.[this.selectedCurrency.toUpperCase()] ?? 1;
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: this.selectedCurrency || 'EUR' }).format(usd * rate);
  }

 

  // ---- Bridge fee (ALTERNATIVE) fiat
  getAltBridgeFeeText(r: any): string {
    // priorité aux USD, sinon si fiat direct présent on le formate
    const bridgeUsd = this.toNumSoft(r?.bridgeFeeUsd);
    if (bridgeUsd != null) return this.usdToSelectedFiat(bridgeUsd);

    const bridgeFiat = this.toNumSoft(r?.bridgeFeeFiat);
    if (bridgeFiat != null) return this.asFiat(bridgeFiat);

    return '—';
  }
}
